<template>
  <el-dialog center :visible.sync="dialog" :before-close="close" :close-on-click-modal="false"
    width="75%">
    <template slot="title">
      <span class="painel-customer-title">Clientes — {{ typeName }}</span>
      <el-tag size="mini" type="info" class="painel-customer-type-tag">tipo {{ typeId }}</el-tag>
    </template>
    <el-row type="flex" justify="end">
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <el-input :placeholder="$t('pesquisar')" prefix-icon="el-icon-search" v-model="filter"></el-input>
      </el-col>
    </el-row>
    <el-table :data="tableData.filter(
      (data) =>
        !filter ||
        data.name.toLowerCase().includes(filter.toLowerCase()) ||
        data.companyname.toLowerCase().includes(filter.toLowerCase()) ||
        (data.federalid || '').toLowerCase().includes(filter.toLowerCase())
    )" stripe style="width: 100%">
      <el-table-column sortable prop="name" :label="$t('cliente')"></el-table-column>
      <el-table-column sortable prop="companyname" :label="$t('nome')"></el-table-column>
      <el-table-column sortable prop="federalid" label="CNPJ/CPF" width="170"></el-table-column>
      <el-table-column sortable prop="email" label="E-mail"></el-table-column>
      <el-table-column sortable prop="createdAt" label="Integrada em" width="130" align="center"></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { IntegrationService } from "@/services/customers/integration.services";

export default {
  name: "IntegrationPainelCustomer",
  data() {
    return {
      dialog: false,
      filter: "",
      tableData: [],
      typeId: "",
      typeName: "",
    };
  },
  methods: {
    open(type, name) {
      const vm = this;
      vm.typeId = type;
      vm.typeName = name || "";
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.painelType(type)
        .then((response) => {
          vm.tableData = response;
          vm.dialog = true;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.painel-customer-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.painel-customer-type-tag {
  margin-left: 8px;
  vertical-align: middle;
}
</style>
